import { render } from "./g-navview.vue?vue&type=template&id=3a8b76ee&ts=true"
import script from "./g-navview.vue?vue&type=script&lang=tsx"
export * from "./g-navview.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__